import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';
import { getImage } from '../services/images.services';
import { useTheme } from '@material-ui/core/styles';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const FullScreenImage = () => {
  const navigate = useNavigate();
  const { src } = useParams();
  const theme = useTheme();
  const [loadingColor] = useState(theme.palette.incorta?.main ?? '');
  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    // Fetch the image using Axios
    const fetchImage = async () => {
      const imagrUrl = await getImage(src);
      setImageUrl(imagrUrl);
    };

    fetchImage();
  }, []);
  return (
    <div>
      <Button
        variant="contained"
        style={{ width: '100px', marginBottom: '2rem' }}
        color="incorta"
        textColor="white"
        onClick={() => navigate(-1)}
      >
        <p style={{ color: 'white' }}>Back</p>
      </Button>
      {imageUrl ? (
        <div>
          <img src={imageUrl} alt="Image" width={'100%'} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        >
          <BeatLoader
            color={loadingColor}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </div>
  );
};

export default FullScreenImage;
